import { render } from "./Analyze.vue?vue&type=template&id=0c509f3e&scoped=true"
import script from "./Analyze.vue?vue&type=script&lang=js"
export * from "./Analyze.vue?vue&type=script&lang=js"

import "./Analyze.vue?vue&type=style&index=0&id=0c509f3e&scoped=true&lang=css"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c509f3e"]])

export default __exports__